import {
    AbstractControl,
    ValidatorFn
} from '@angular/forms';

export const REQUIRED_ERROR_KEY: string = 'autocompleteRequired';

export const required: ValidatorFn = (
    control: AbstractControl
): { [key: string]: any } | null => {
    const valid: boolean =
        Array.isArray(control?.value) && control.value.length >= 1;

    return !valid ? { [REQUIRED_ERROR_KEY]: { value: control.value } } : null;
};
